import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { MySpmElemComitatoGestioneEntity } from '../../../../models/interfaces/revisione.interface';
import { controlloCheckComitatoControllo } from '../../common/helpers/norme-spa-helpers.helper';
import { getSpmComitatoGestioneFormArray } from '../validators/helpers/norme-spa-monistico-form-validators.helper';
import { withCkNormeGuard } from '../../common/operators/with-ck-norme-guard.operator';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';

export const setNormeSpaMonisticoSpmSpecificListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_SpmElemComitatoGestione(form, store);
};

const my_SpmElemComitatoGestione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const formArray = getSpmComitatoGestioneFormArray(form);

    // Guard: senza, l'array vuoto di un verbale non monistico riscriveva my_ControlloRevLegali = '0' sullo store.
    formArray.valueChanges.pipe(withChangeDebounced(formArray), withCkNormeGuard(form, CkNormeValuesEnum.normeSpaMonistico)).subscribe((elem: MySpmElemComitatoGestioneEntity[]) => {
        controlloCheckComitatoControllo(form, store, elem);
    });
};
